import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {exhaustMap, map, mergeMap} from "rxjs/operators";
import {StoreItemActions} from "./store-item.actions";
import {NotificationService} from "../../../services/notification.service";
import {PaginationService} from "../../../services/pagination.service";
import {switchMap} from "rxjs";
import {AppState} from "../../reducers";
import _ from "lodash";


@Injectable()
export class StoreItemEffects {

  create$ = createEffect(() => this.actions$.pipe(
      ofType(StoreItemActions.createUpdateStoreItem),
      exhaustMap((action) => {
        return this.apollo
          .mutate({
            mutation: _.cloneDeep(action?.mutation),
            variables: {input: action?.input}
          })
          .pipe(
            map(({data}: any) => {
              const result: any = Object.values(data)[0]
              if (result?.response?.status) {
                this.notificationService.successMessage(result?.response?.message)
                this.store.dispatch(StoreItemActions.upsertStoreItem({
                  storeItem: result?.data,
                  entity: action?.entity
                }));
              } else {
                this.notificationService.errorMessage(result?.response?.message);
              }
            })
          );
      })
    ),
    {dispatch: false}
  );

  delete$ = createEffect(() => this.actions$.pipe(
      ofType(StoreItemActions.removeStoreItem),
      exhaustMap((action) => {
        return this.apollo
          .mutate({
            mutation: _.cloneDeep(action?.mutation),
            variables: action?.input
          })
          .pipe(
            map(({data}: any) => {
              const result: any = Object.values(data)[0]
              if (result?.response?.status) {
                this.notificationService.successMessage(result?.response?.message)
                this.store.dispatch(StoreItemActions.deleteStoreItem({
                  id: action?.id,
                  entity: action?.entity
                }));
              } else {
                this.notificationService.errorMessage(result?.response?.message);
              }
            })
          );
      })
    ),
    {dispatch: false}
  );

  get$ = createEffect(() => this.actions$.pipe(
    ofType(StoreItemActions.getStoreItems),
    switchMap((action) => {
      return this.apollo.query({
        query: _.cloneDeep(action?.query),
        variables: action?.isNotFiltering ? action?.filtering : { filtering: action?.filtering }
      }).pipe(
        map(({data}: any) => {
          const result: any = Object.values(data)[0];
          if (result?.response?.status) {
            if (result?.page) {
              // todo: pagination
            }
            this.store.dispatch(StoreItemActions.loadStoreItems({ storeItems: result?.data, entity: action?.entity }));
          } else {
            this.notificationService.errorMessage(result?.response?.message);
          }
        })
      );
    })
  ), {dispatch: false});

  getStoreItemsMergeMap$ = createEffect(() => this.actions$.pipe(
    ofType(StoreItemActions.getStoreItemsMergeMap),
    mergeMap((action) => {
      return this.apollo.query({
        query: _.cloneDeep(action?.query),
        variables: action?.isNotFiltering ? action?.filtering : { filtering: action?.filtering }
      }).pipe(
        map(({data}: any) => {
          const result: any = Object.values(data)[0];
          if (result?.response?.status) {
            if (result?.page) {
              // todo: pagination
            }
            this.store.dispatch(StoreItemActions.loadStoreItems({ storeItems: result?.data, entity: action?.entity }));
          } else {
            this.notificationService.errorMessage(result?.response?.message);
          }
        })
      );
    })
  ), {dispatch: false});


  constructor(private actions$: Actions,
              private apollo: Apollo,
              private store: Store<AppState>,
              private notificationService: NotificationService,
              private paginationService: PaginationService
  ) {
  }
}
